import { config } from '../config';
import { RpcError } from './errors';

/** 006 のポリシーが許すパス: {event_id}/{team_id}/{uuid}.{ext} */
export function photoPath(eventId: string, teamId: string, ext: 'jpg' | 'png' | 'webp' = 'jpg'): string {
  return `${eventId}/${teamId}/${crypto.randomUUID()}.${ext}`;
}

export function photoUrl(path: string): string {
  return `${config.supabaseUrl}/storage/v1/object/public/${config.photoBucket}/${path}`;
}

/**
 * 写真を送る。進み具合を出すため fetch でなく XHR を使う（図鑑㉛b）。
 * 同じパスがすでにあれば成功とみなす（圏外の再送で二重にならない。上書きはポリシーで不可）
 */
export function uploadPhoto(path: string, blob: Blob, onProgress?: (ratio: number) => void): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${config.supabaseUrl}/storage/v1/object/${config.photoBucket}/${path}`);
    xhr.setRequestHeader('apikey', config.anonKey);
    xhr.setRequestHeader('Authorization', `Bearer ${config.anonKey}`);
    xhr.setRequestHeader('Content-Type', blob.type || 'image/jpeg');
    xhr.setRequestHeader('x-upsert', 'false');
    xhr.timeout = 60_000;
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) onProgress(e.loaded / e.total);
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) return resolve();
      if (xhr.status === 409 || /Duplicate|already exists/i.test(xhr.responseText)) return resolve();
      reject(new RpcError('unknown', `upload ${xhr.status}: ${xhr.responseText.slice(0, 200)}`));
    };
    xhr.onerror = () => reject(new RpcError('network', 'upload failed'));
    xhr.ontimeout = () => reject(new RpcError('network', 'upload timeout'));
    xhr.send(blob);
  });
}
